export const hardQuestions: string[] = [
  // À remplir
];

export const hardActions: string[] = [
  // À remplir
];
